<template>
  <Card
    class="act-wrap"
    :padding="0"
    :title="l.title"
    :bordered="false"
    :shadow="false"
    @click.native="handleClick"
  >
    <div class="act-header" slot="title">
      <div class="act-header-main">
        <div class="act-header-title">
          <span>{{(l.event_type === 1 ? "关键活动: " : "例行活动 ") + l.title}}</span>
          <span v-if="l.is_finish === 1" class="tag success">已打卡</span>
          <span v-if="l.date_show && l.is_finish === 0" class="tag warning">未打卡</span>
          <span v-if="l.is_finish === 1 && l.is_execute === 0" class="tag error">{{ l.result }}</span>
          <span v-if="l.status === 1" class="tag error">医生停用</span>
        </div>
        <div class="act-header-label" v-if="l.start_time">
          <span :style="{marginRight: l.is_finish === 1 ? '10px' : '0px'}">
          {{ "计划时间:" + l.start_time.slice(10, 16) }}
          </span>
          <span v-if="l.is_finish === 1">
            执行时间: {{l.execute_time && l.execute_time.slice(0, 16)}}
          </span>
        </div>
      </div>
      <div class="act-header-value" v-if="is_edit">
        <img v-if="l.is_finish === 1"
          style="width: 24px;height: 24px;"
          src="../../../images/icon_select.png" alt=""
          @click.stop="cancelPunch"/>
        <img v-else
          style="width: 24px;height: 24px;"
          src="../../../images/icon_unselect.png" alt=""/>
      </div>
    </div>
    <div class="act-main">
      <act-btn v-for="(act, index) in l.list" :key="index" :u="act" :is_redirect="is_redirect"/>
    </div>
  </Card>
</template>
<script>
import ActBtn from "./activityButton.vue";
export default {
  components: {
    ActBtn,
  },
  props: {
    l: {
      type: Object,
      default: () => ({}),
    },
    is_redirect: {
      type: Boolean,
      default: true,
    },
    is_edit: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    cancelPunch() {
      this.$emit('on-cancel', this.l);
    },
    handleClick() {
      this.$emit('on-click', this.l);
    }
  }
};
</script>
<style lang="less">
.act-wrap {
  line-height: 1.2;
  font-weight: 500;
  color: rgb(130, 143, 164);
  background-color: #f6f8fc;
  border-color: #eee;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 20%);
  cursor: pointer;
  .ivu-card-head {
    border-bottom-style: dashed;
  }
  .act-header {
    display: flex;
    align-items: center;
    &-main{
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    &-value{
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    &-label {
      font-size: 14px;
      color: rgba(130, 143, 164, 0.7);
      line-height: 1.5;
      >span{
        font-size: 14px;
        display: inline-block;
      }
    }
    &-title {
      font-size: 15px;
      margin-bottom: 4px;
      >span{
        vertical-align: middle;
        line-height: normal;
      }
      .tag {
        display: inline-block;
        margin-left: 4px;
        color: #fff;
        padding: 2px 4px;
        border-radius: 4px;
        font-size: 12px;
        &.success {
          background: #3eca9a;
        }
        &.warning {
          background: #ff9e00;
        }
        &.error {
          background: #ed4014;
        }
      }
    }
  }
  .act-btn{
    &-oper{
      font-weight: 600;
      cursor: pointer;
      color: #5d7ff8;
      & + &{
        margin-left: 4px;
      }
      i {
        font-size: 20px;
      }
      &:hover {
        color: #5d7ff8;
        opacity: 0.8;
      }
    }
  }
}
</style>
